const JOBS = {
  id: 'jobs',
  title: 'Jobs',
};

const ADVERTISEMENTS = {
  id: 'advertisements',
  title: 'Advertisements',
};

const FOLLOW_UP = {
  id: 'follow-up',
  title: 'Follow up',
};

export const emailCategories = { JOBS, ADVERTISEMENTS, FOLLOW_UP };

export const EMAIL_TYPE_IDS = {
  MARKETING: 1,
  TRANSACTIONAL: 2,
  GROWTH: 3,
  OUTBOUND: 4,
};

export default {};
